<template>
  <b-modal id="modal-request-approval" ref="modal" size="lg" title=" Overtime Approval" @show="setData" :hide-footer="hideButton">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-user"></em> General Information</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{detail.emp_name}}
                </div>
              </div>
              <div class="form-row" v-if="data !== null">
                <label class="col-md-3">Transaction Number</label>
                <div class="col-md-6 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row" >
                <label class="col-md-3">Time</label>
                <div class="col-md-6 mb-3">
                  {{detail.start}} - {{detail.end}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Note</label>
                <div class="col-md-6 mb-3">
                  {{detail.reason}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-6 mb-3">
                  {{detail.stat_name}}
                </div>
              </div>
              <hr/>
              <legend><em class="fa fa-users"></em> Approval Information</legend>
              <list-supervisor-finish :list_supervisor="list_supervisor" v-if="!arr_status.includes(detail.comp_stat_id)"></list-supervisor-finish>
              <list-supervisor :emp_id="detail.emp_id.toString()" v-else></list-supervisor>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer >
      <div class="w-100">
        <button class="btn btn-success float-right mr-1" @click="stat_id=3;handleOk($event)"> Approve </button>
        <button class="btn btn-danger float-right mr-1" @click="stat_id=5; handleOk($event)"> Reject </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from 'bootstrap-vue'
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
import ListSupervisorFinish from "../employee/ListSupervisorFinish";
export default {
  name: "OvertimeApproval",
  components:{ListSupervisorFinish, ListSupervisor, BModal, BForm},
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      stat_id:1,
      hideButton:false,
      list_supervisor:[],
      detail:{},
      arr_status:[0],
      arr_action:['rejected', 'approved', 'cancelled'],
      items:[]
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        this.getDetail()
      }, 100)
    },
    handleOk(evt){
      evt.preventDefault()
      let payload = {
        stat_id:this.stat_id,
        emp_id:this.$store.getters.empId,
        trans_id:this.data.trans_id,
        master_id:this.data.master_id,
        log_id:this.data.id
      }

      AxiosCall.Post(payload, urlApi.overtime.approval).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$refs.modal.hide()
          this.$parent.getData()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    getDetail(){
      this.items = []
      let payload = {
        id:this.data.master_id
      }

      AxiosCall.Get(payload, urlApi.overtime.detail).then(res=>{
        if(res.success){
          this.detail = res.atributes
          this.checkButtonApproval()
          if(!this.arr_status.includes(res.atributes.comp_stat_id)) this.getListSupervisor()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    checkButtonApproval(){
      this.hideButton =  ((this.detail.emp_id == this.$store.getters.empId) && this.arr_action.includes(this.data.action) ) ? true :false
    },
    getListSupervisor(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.overtime.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
          for(let dt of this.list_supervisor){
            if(dt.emp_id == this.$store.getters.empId && dt.status_name !== null ) {
              this.hideButton = true
              break
            }
          }
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  }
}
</script>